export default __webpack_public_path__ + "static/media/law.8a4c56ab.svg";